import { render, staticRenderFns } from "./EsgGhgEmissionMgmtByOrgs.vue?vue&type=template&id=95560c3c&scoped=true"
import script from "./EsgGhgEmissionMgmtByOrgs.vue?vue&type=script&lang=js"
export * from "./EsgGhgEmissionMgmtByOrgs.vue?vue&type=script&lang=js"
import style0 from "./EsgGhgEmissionMgmtByOrgs.vue?vue&type=style&index=0&id=95560c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95560c3c",
  null
  
)

export default component.exports